import { put, takeLatest, call, throttle } from 'redux-saga/effects';
import {
  allJobsSuccess,
  allJobsFailure,
  allJobsRequest,
  loadJobRequest,
  loadedJobRequest,
  errorJobRequest,
} from '../actions/jobs';
import SearchClient from '../../api/SearchClient';
import SentryAPI from '../../api/SentryAPI';
import { get } from '../../api';

export function* allJobsRequestEvent({ payload }) {
  const { network } = payload;
  const query = Object.keys(payload.query).reduce((acc, key) => {
    switch (key) {
      case 'head_count':
      case 'industry_tags':
      case 'stage':
        acc[`organization.${key}`] = payload.query[key];
        break;
      default:
        acc[key] = payload.query[key];
    }

    return acc;
  }, {});

  delete query.stage;
  delete query.headCount;
  delete query.industryTags;

  if (query.page) {
    query.page = parseInt(query.page, 10) - 1;
  }

  Object.keys(query).forEach((key) => {
    if (key.includes('organization.topics')) {
      if (!('organization.topics' in query)) {
        query['organization.topics'] = {};
      }

      query['organization.topics'][key.replace('organization.topics.', '')] = query[key];

      delete query[key];
    }
  });

  try {
    const response = yield call(SearchClient.findJobs, {
      query: query.q,
      network,
      page: query.page,
      filters: query,
    });
    yield put(allJobsSuccess(response));
  } catch (e) {
    yield put(allJobsFailure({ error: e }));
  }
}

export function* loadJobEvent({ payload }) {
  const { jobSlug, network } = payload;
  try {
    const result = yield call(get, `/jobs/${jobSlug}?collection_id=${network.id}`);
    const { data } = result;
    yield put(loadedJobRequest(data));
  } catch (e) {
    if (typeof window === 'undefined' || window.navigator.onLine) {
      yield call(SentryAPI.trackError, 'Load Job Event', {
        networkId: network.id,
        jobSlug,
        e,
      });
    }

    yield put(errorJobRequest(e));
  }
}

export default function* jobsInitializeRequestWatcher() {
  yield takeLatest(allJobsRequest().type, allJobsRequestEvent);
  yield throttle(1000, loadJobRequest().type, loadJobEvent);
}
